import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: {
    items: [],
    payment_array: [],
    amount_from_payment_methods: 0.0,
    remaining_amount: 0.0,
    totalPrice: 0.0,
    subTotalPrice: 0.0,
    cash_discount: 0.0,
    customer_id: null,
    customer_name: "",
    customer_email: null,
    customer_number: "",
    customer_country_code: "",
    customer_address: null,
    customer_allow_pay_later: false,
    customer_credit_amount: 0,
    delivery_charge: 0.0,
    is_order: false,
    is_paid: false,
    percent_discount: 0.0,
    tax: 0.0,
    tax_rate: {
      rate: 0,
      status: false,
      allow_exemp: false,
      type: "",
      category: "",
      description: "",
    },
    note: "",
    totalItems: 0,
    saleId: null,
  },
};

const cart = createSlice({
  name: "cart",
  initialState,
  reducers: {
    updateTaxRate: (state, data) => {
      state.value.tax_rate = data.payload.tax_rate;
      state.value.tax = 0;
      if (state.value.tax_rate?.status) {
        if (state.value.tax_rate?.rate > 0 && state.value.subTotalPrice > 0) {
          let temp_total_price = 0.0;

          state.value.totalItems = 0;
          state.value.items.forEach((item, index) => {
            const product_price = Number(item?.product?.price);
            const reduced_price = Number(item?.product?.reduced_price);
            const actual_amount =
              reduced_price > 0 ? reduced_price : product_price;
            const product_quantity = Number(item?.quantity);
            state.value.totalItems += product_quantity;

            state.value.items[index].product.base_price = actual_amount;

            let itemTotalPrice = 0;
            if (state.value.tax_rate?.status) {
              if (state.value.tax_rate?.type === "include_in_price") {
                if (state.value.tax_rate?.category === "percentage") {
                  const base_price =
                    actual_amount /
                    (1 + Number(state.value.tax_rate?.rate) / 100);

                  state.value.items[index].product.base_price =
                    Number(base_price).toFixed(2);

                  const product_tax_amount = Number(
                    actual_amount - base_price
                  ).toFixed(2);
                  state.value.tax += product_tax_amount * product_quantity;
                } else if (state.value.tax_rate?.category === "fixed") {
                  state.value.items[index].product.base_price = Number(
                    actual_amount - Number(state.value.tax_rate?.rate)
                  ).toFixed(2);
                  state.value.tax +=
                    Number(state.value.tax_rate?.rate) * product_quantity;
                }
              }
            }
            itemTotalPrice = actual_amount * product_quantity;

            temp_total_price += item?.discount
              ? itemTotalPrice - Number(item?.discount)
              : itemTotalPrice;
          });

          state.value.subTotalPrice = temp_total_price.toFixed(2);
          if (state.value.tax_rate?.type === "add_to_price") {
            if (state.value.tax_rate?.category === "percentage") {
              state.value.tax = (
                (Number(state.value.tax_rate?.rate) * temp_total_price) /
                100
              ).toFixed(2);
            } else if (state.value.tax_rate?.category === "fixed") {
              state.value.tax = Number(state.value.tax_rate?.rate).toFixed(2);
            }
          }
          state.value.tax = Number(state.value.tax).toFixed(2);
          state.value.cash_discount = (
            (Number(state.value.percent_discount) * temp_total_price) /
            100
          ).toFixed(2);

          state.value.totalPrice = (
            temp_total_price +
            Number(
              state.value.tax_rate?.type === "add_to_price"
                ? state.value.tax
                : 0
            ) +
            Number(state.value.delivery_charge) -
            Number(state.value.cash_discount)
          ).toFixed(2);
          state.value.remaining_amount = Number(
            state.value.totalPrice - state.value.amount_from_payment_methods
          ).toFixed(2);
        }
      }
    },
    addItemToCart: (state, data) => {
      const { newItem } = data.payload;
      const alreadyExists = state.value.items.find(
        (el) => el?.product?.id === newItem?.product?.id
      );

      if (alreadyExists) {
        if (alreadyExists?.nonInventory) {
          alreadyExists.product.quantity += newItem.product.quantity;
        } else {
          alreadyExists.quantity += newItem.quantity;
        }
      } else {
        state.value.items.push({
          ...newItem,
          product: { ...newItem?.product, base_price: 0 },
        });
      }

      let temp_total_price = 0.0;

      state.value.totalItems = 0;
      state.value.tax = 0;
      state.value.items.forEach((item, index) => {
        const product_price = Number(item?.product?.price);
        const reduced_price = Number(item?.product?.reduced_price);
        const actual_amount = reduced_price > 0 ? reduced_price : product_price;
        const product_quantity = Number(item?.quantity);
        state.value.totalItems += product_quantity;

        state.value.items[index].product.base_price = actual_amount;

        let itemTotalPrice = 0;
        if (state.value.tax_rate?.status) {
          if (state.value.tax_rate?.type === "include_in_price") {
            if (state.value.tax_rate?.category === "percentage") {
              const base_price =
                actual_amount / (1 + Number(state.value.tax_rate?.rate) / 100);

              state.value.items[index].product.base_price =
                Number(base_price).toFixed(2);

              const product_tax_amount = Number(
                actual_amount - base_price
              ).toFixed(2);
              state.value.tax += product_tax_amount * product_quantity;
            } else if (state.value.tax_rate?.category === "fixed") {
              state.value.items[index].product.base_price = Number(
                actual_amount - Number(state.value.tax_rate?.rate)
              ).toFixed(2);
              state.value.tax +=
                Number(state.value.tax_rate?.rate) * product_quantity;
            }
          }
        }
        itemTotalPrice = actual_amount * product_quantity;

        temp_total_price += item?.discount
          ? itemTotalPrice - Number(item?.discount)
          : itemTotalPrice;
      });

      state.value.subTotalPrice = temp_total_price.toFixed(2);
      if (state.value.tax_rate?.status) {
        if (state.value.tax_rate?.type === "add_to_price") {
          if (state.value.tax_rate?.category === "percentage") {
            state.value.tax = (
              (Number(state.value.tax_rate?.rate) * temp_total_price) /
              100
            ).toFixed(2);
          } else if (state.value.tax_rate?.category === "fixed") {
            state.value.tax = Number(state.value.tax_rate?.rate).toFixed(2);
          }
        }
      }
      state.value.tax = Number(state.value.tax).toFixed(2);
      state.value.cash_discount = (
        (Number(state.value.percent_discount) * temp_total_price) /
        100
      ).toFixed(2);
      state.value.totalPrice = (
        temp_total_price +
        Number(
          state.value.tax_rate?.type === "add_to_price" ? state.value.tax : 0
        ) +
        Number(state.value.delivery_charge) -
        Number(state.value.cash_discount)
      ).toFixed(2);
      state.value.remaining_amount = Number(
        state.value.totalPrice - state.value.amount_from_payment_methods
      ).toFixed(2);
    },

    removeItemFromCart: (state, data) => {
      const { newItem } = data.payload;
      const alreadyExists = state.value.items.find(
        (el) => el?.product?.id === newItem?.product?.id
      );

      if (alreadyExists) {
        if(data.payload?.removeAll){
          const itemIndex = state.value.items.findIndex(
            (el) => el?.product?.id === newItem?.product?.id
          );
          if (itemIndex !== -1) {
            state.value.items.splice(itemIndex, 1);
          }
        }else{
          if (alreadyExists.nonInventory) {
            if (alreadyExists.product.quantity > 1) {
              alreadyExists.product.quantity -= 1;
            } else {
              const itemIndex = state.value.items.findIndex(
                (el) => el?.product?.id === newItem?.product?.id
              );
              if (itemIndex !== -1) {
                state.value.items.splice(itemIndex, 1);
              }
            }
          } else {
            if (alreadyExists.quantity > 1) {
              alreadyExists.quantity -= 1;
            } else {
              const itemIndex = state.value.items.findIndex(
                (el) => el?.product?.id === newItem?.product?.id
              );
              if (itemIndex !== -1) {
                state.value.items.splice(itemIndex, 1);
              }
            }
          }
        }

        let temp_total_price = 0.0;

        state.value.totalItems = 0;
        state.value.tax = 0;
        state.value.items.forEach((item, index) => {
          const product_price = Number(item?.product?.price);
          const reduced_price = Number(item?.product?.reduced_price);
          const actual_amount =
            reduced_price > 0 ? reduced_price : product_price;
          const product_quantity = Number(item?.quantity);
          state.value.totalItems += product_quantity;

          state.value.items[index].product.base_price = actual_amount;

          let itemTotalPrice = 0;
          if (state.value.tax_rate?.status) {
            if (state.value.tax_rate?.type === "include_in_price") {
              if (state.value.tax_rate?.category === "percentage") {
                const base_price =
                  actual_amount /
                  (1 + Number(state.value.tax_rate?.rate) / 100);

                state.value.items[index].product.base_price =
                  Number(base_price).toFixed(2);

                const product_tax_amount = Number(
                  actual_amount - base_price
                ).toFixed(2);
                state.value.tax += product_tax_amount * product_quantity;
              } else if (state.value.tax_rate?.category === "fixed") {
                state.value.items[index].product.base_price = Number(
                  actual_amount - Number(state.value.tax_rate?.rate)
                ).toFixed(2);
                state.value.tax +=
                  Number(state.value.tax_rate?.rate) * product_quantity;
              }
            }
          }
          itemTotalPrice = actual_amount * product_quantity;

          temp_total_price += item?.discount
            ? itemTotalPrice - Number(item?.discount)
            : itemTotalPrice;
        });

        state.value.subTotalPrice = temp_total_price.toFixed(2);
        if (state.value.tax_rate?.status) {
          if (state.value.tax_rate?.type === "add_to_price") {
            if (state.value.tax_rate?.category === "percentage") {
              state.value.tax = (
                (Number(state.value.tax_rate?.rate) * temp_total_price) /
                100
              ).toFixed(2);
            } else if (state.value.tax_rate?.category === "fixed") {
              state.value.tax = Number(state.value.tax_rate?.rate).toFixed(2);
            }
          }
        }
        state.value.tax = Number(state.value.tax).toFixed(2);
        state.value.cash_discount = (
          (Number(state.value.percent_discount) * temp_total_price) /
          100
        ).toFixed(2);
        state.value.totalPrice = (
          temp_total_price +
          Number(
            state.value.tax_rate?.type === "add_to_price" ? state.value.tax : 0
          ) +
          Number(state.value.delivery_charge) -
          Number(state.value.cash_discount)
        ).toFixed(2);
        state.value.remaining_amount = Number(
          state.value.totalPrice - state.value.amount_from_payment_methods
        ).toFixed(2);
      }
    },

    addDiscountDetails: (state, data) => {
      state.value.cash_discount = data.payload.cash_discount;
      state.value.percent_discount = data.payload.percent_discount;
      state.value.totalPrice = data.payload.totalPrice;
      state.value.remaining_amount = Number(
        state.value.totalPrice - state.value.amount_from_payment_methods
      ).toFixed(2);
    },

    addNoteToCheckout: (state, data) => {
      state.value.note = data.payload.note;
    },

    addDeliveryFee: (state, data) => {
      state.value.delivery_charge = Number(
        data.payload.delivery_charge
      ).toFixed(2);
      state.value.totalPrice = (
        Number(state.value.subTotalPrice) +
        Number(state.value.tax) +
        Number(state.value.delivery_charge) -
        Number(state.value.cash_discount)
      ).toFixed(2);
      state.value.remaining_amount = Number(
        state.value.totalPrice - state.value.amount_from_payment_methods
      ).toFixed(2);
    },

    clearCart: (state) => {
      const tax = 0;
      const tax_rate = state.value.tax_rate;
      return {
        value: {
          ...initialState.value,
          tax: tax,
          tax_rate: tax_rate,
        },
      };
    },

    addPaymentArray: (state, data) => {
      const { paymentMethod } = data.payload;
      let alreadyExists = state.value.payment_array.find(
        (el) => el.payment_method === paymentMethod.payment_method
      );

      if (alreadyExists) {
        alreadyExists.amount = (
          Number(paymentMethod.amount) + Number(alreadyExists.amount)
        ).toFixed(2);
      } else {
        state.value.payment_array.push(paymentMethod);
      }

      let paid_amount = 0.0;
      state.value.payment_array.forEach((el) => {
        paid_amount = (Number(el.amount) + Number(paid_amount)).toFixed(2);
      });

      state.value.amount_from_payment_methods = paid_amount;
      state.value.remaining_amount = Number(
        Number(state.value.totalPrice) -
          Number(state.value.amount_from_payment_methods)
      ).toFixed(2);
    },

    removeFromPaymentArray: (state, data) => {
      const { paymentMethod } = data.payload;
      let alreadyExists = state.value.payment_array.findIndex(
        (el) => el.payment_method === paymentMethod.payment_method
      );

      if (alreadyExists !== -1) {
        state.value.payment_array.splice(alreadyExists, 1);

        let paid_amount = 0.0;
        state.value.payment_array.forEach((el) => {
          paid_amount = (Number(el.amount) + Number(paid_amount)).toFixed(2);
        });

        state.value.amount_from_payment_methods = paid_amount;
        state.value.remaining_amount = Number(
          Number(state.value.totalPrice) -
            Number(state.value.amount_from_payment_methods)
        ).toFixed(2);
      }
    },

    updatePaymentCustomerDetails: (state, data) => {
      const {
        customer_name,
        customer_email,
        customer_number,
        customer_country_code,
        customer_id,
        customer_address,
        customer_allow_pay_later,
        customer_credit_amount,
      } = data.payload;

      state.value.customer_name = customer_name;
      state.value.customer_email = customer_email;
      state.value.customer_number = customer_number;
      state.value.customer_country_code = customer_country_code;
      state.value.customer_id = customer_id;
      state.value.customer_address = customer_address;
      state.value.customer_allow_pay_later = customer_allow_pay_later;
      state.value.customer_credit_amount = customer_credit_amount;
    },

    clearPaymentCustomerDetails: (state) => {
      state.value.customer_name = "";
      state.value.customer_email = null;
      state.value.customer_number = "";
      state.value.customer_country_code = "";
      state.value.customer_id = null;
      state.value.customer_address = null;
      state.value.customer_allow_pay_later = false;
      state.value.customer_credit_amount = 0;
    },

    addItemDiscount: (state, data) => {
      const { item, discount } = data.payload;
      const alreadyExists = state.value.items.find(
        (el) => el?.product?.id === item?.product?.id
      );

      if (alreadyExists) {
        alreadyExists.discount = Number(discount);

        let temp_total_price = 0.0;

        state.value.totalItems = 0;
        state.value.tax = 0;
        state.value.items.forEach((item, index) => {
          const product_price = Number(item?.product?.price);
          const reduced_price = Number(item?.product?.reduced_price);
          const actual_amount =
            reduced_price > 0 ? reduced_price : product_price;
          const product_quantity = Number(item?.quantity);
          state.value.totalItems += product_quantity;

          state.value.items[index].product.base_price = actual_amount;

          let itemTotalPrice = 0;
          if (state.value.tax_rate?.status) {
            if (state.value.tax_rate?.type === "include_in_price") {
              if (state.value.tax_rate?.category === "percentage") {
                const base_price =
                  actual_amount /
                  (1 + Number(state.value.tax_rate?.rate) / 100);

                state.value.items[index].product.base_price =
                  Number(base_price).toFixed(2);

                const product_tax_amount = Number(
                  actual_amount - base_price
                ).toFixed(2);
                state.value.tax += product_tax_amount * product_quantity;
              } else if (state.value.tax_rate?.category === "fixed") {
                state.value.items[index].product.base_price = Number(
                  actual_amount - Number(state.value.tax_rate?.rate)
                ).toFixed(2);
                state.value.tax +=
                  Number(state.value.tax_rate?.rate) * product_quantity;
              }
            }
          }
          itemTotalPrice = actual_amount * product_quantity;

          temp_total_price += item?.discount
            ? itemTotalPrice - Number(item?.discount)
            : itemTotalPrice;
        });

        state.value.subTotalPrice = temp_total_price.toFixed(2);
        if (state.value.tax_rate?.status) {
          if (state.value.tax_rate?.type === "add_to_price") {
            if (state.value.tax_rate?.category === "percentage") {
              state.value.tax = (
                (Number(state.value.tax_rate?.rate) * temp_total_price) /
                100
              ).toFixed(2);
            } else if (state.value.tax_rate?.category === "fixed") {
              state.value.tax = Number(state.value.tax_rate?.rate).toFixed(2);
            }
          }
        }
        state.value.tax = Number(state.value.tax).toFixed(2);
        state.value.cash_discount = (
          (Number(state.value.percent_discount) * temp_total_price) /
          100
        ).toFixed(2);
        state.value.totalPrice = (
          temp_total_price +
          Number(
            state.value.tax_rate?.type === "add_to_price" ? state.value.tax : 0
          ) +
          Number(state.value.delivery_charge) -
          Number(state.value.cash_discount)
        ).toFixed(2);
        state.value.remaining_amount = Number(
          state.value.totalPrice - state.value.amount_from_payment_methods
        ).toFixed(2);
      }
    },
    editSaleCart: (state, data) => {
      state.value.saleId = data.payload.saleId;
      state.value.tax = data.payload.tax;
      state.value.tax_rate = data.payload.tax_rate;
      state.value.delivery_charge = data.payload.delivery_charge;
      state.value.cash_discount = data.payload.cash_discount;
      state.value.percent_discount = data.payload.percent_discount;
    },
  },
});

export const {
  updateTaxRate,
  addItemToCart,
  removeItemFromCart,
  addDiscountDetails,
  clearCart,
  addNoteToCheckout,
  addDeliveryFee,
  addPaymentArray,
  removeFromPaymentArray,
  updatePaymentCustomerDetails,
  clearPaymentCustomerDetails,
  addItemDiscount,
  editSaleCart,
} = cart.actions;

export default cart.reducer;
